export const AGREEMENTS_TYPES = {
	COOKIES: 'COOKIES',
	LOGIN: 'LOGIN',
	MARKETING: 'MARKETING',
	PAYMENT: 'PAYMENT',
	PAYMENT_SUBSCRIPTION: 'PAYMENT_SUBSCRIPTION',
	PAYMENT_RENEWAL: 'PAYMENT_RENEWAL',
	INVOICE: 'INVOICE',
	REGISTRATION: 'REGISTRATION',
	RODO: 'RODO',
	SUBSCRIBER: 'SUBSCRIBER'
};

const {
	REGISTRATION,
	MARKETING,
	SUBSCRIBER,
	PAYMENT_RENEWAL,
	INVOICE
} = AGREEMENTS_TYPES;

export const REGISTER_AGREEMENTS = [REGISTRATION, MARKETING];
export const ENABLED_OBLIGATORY_AGREEMENTS = [PAYMENT_RENEWAL];
export const AGREEMENT_WITH_MODAL_APPROVE = [PAYMENT_RENEWAL];

export const AGREEMENT_MODAL_DATA = {
	PAYMENT_RENEWAL: {
		description: 'agreements_payment_renewal_modal_decline_description'
	}
};

export const SUBSCRIBER_PROFILE_AGREEMENTS = [
	REGISTRATION,
	SUBSCRIBER,
	PAYMENT_RENEWAL,
	INVOICE,
	MARKETING
];
